import * as Yup from 'yup';

const UpdateBankSchema = Yup.object().shape({
    // bankNo: Yup.string()
    //     .trim()
    //     .required('Bank is required'),
    accountNo: Yup.string()
        .trim()
        .required('Account Number is required'),
    accountNoConfirm: Yup.string()
        .trim()
        .required('Account Number is required'),
    branchNo: Yup.string()
        .trim()
        .required('Branch is required'),
});

export default UpdateBankSchema;
